import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import copyToClipboard from 'copy-to-clipboard';

import { StaticVideo } from '../../../../../../../types/items';
import { ButtonGroup } from '../../../../../../../components';
import { selectMediaExport } from '../../../../../../../store/modules/articles/selectors';
import { notify } from '../../../../../../../store/modules/notifications/actions';
import useStyles from '../styles';
import { getQuality } from '../../../utils';

const CopyVideoLinkAction = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { media } = useSelector(selectMediaExport);

  const clickHandler = useCallback((staticVideo: StaticVideo) => {
    return () => {
      if (copyToClipboard(staticVideo.url)) {
        dispatch(
          notify({
            type: 'info',
            icon: 'copy',
            message: 'MP4 URL copied.',
          }),
        );
      } else {
        dispatch(
          notify({
            type: 'error',
            icon: 'copy',
            message: 'MP4 URL copying failed.',
          }),
        );
      }
    };
  }, [dispatch]);

  if (media && media.ref.video) {
    const { video } = media.ref;
    if (video.ref.statics) {
      const buttons = video.ref.statics.map((item) => {
        return {
          title: `Copy`,
          titleList: `Copy Link ${getQuality(item.name)}`,
          onClick: clickHandler(item),
          disabled: false,
        };
      }).reverse();

      return (
        <ButtonGroup
          buttons={buttons}
          color="default"
          variant="text"
          className={classes.groupAction}
        />
      );
    }
  }

  return null;
};

export default CopyVideoLinkAction;
